import * as Sentry from "@sentry/react";
import { Blac } from "blac-next";
import { FeatureResponse } from "@9amhealth/openapi";
import AssumedIdentityCubit from "src/state/AssumedIdentityCubit/AssumedIdentityCubit";
import { featureFlags } from "./featureFlags";
import reportErrorSentry from "./reportErrorSentry";
import type { replayIntegration } from "./sentryReplayIntegration";

let replayWanted = false;
let replayLoading = false;

// Sentry.getReplay would pull the replay code into the main bundle.
const getReplay = () =>
  Sentry.getClient()?.getIntegrationByName<
    ReturnType<typeof replayIntegration>
  >("Replay");

export const stopSentryReplay = async (): Promise<void> => {
  replayWanted = false;
  Sentry.setTag("replay_enabled", undefined);
  await getReplay()?.stop();
};

export const startSentryReplay = async (): Promise<void> => {
  const client = Sentry.getClient<Sentry.BrowserClient>();
  if (!client) {
    return;
  }

  try {
    await featureFlags.ready;
    const allowed =
      !Blac.getBloc(AssumedIdentityCubit).isActive &&
      featureFlags.getRemoteFlag(FeatureResponse.feature.SENTRY_REPLAY) ===
        true;
    if (!allowed) {
      await stopSentryReplay();
      return;
    }
    replayWanted = true;
    Sentry.setTag("replay_enabled", true);

    const replay = getReplay();
    if (replay) {
      replay.start();
      return;
    }
    if (replayLoading) {
      return;
    }
    replayLoading = true;

    try {
      const { replayIntegration } = await import("./sentryReplayIntegration");
      if (!replayWanted) {
        return;
      }
      client.getOptions().replaysSessionSampleRate = 1;
      Sentry.addIntegration(
        replayIntegration({
          maskAllText: true,
          maskAllInputs: true,
          blockAllMedia: true
        })
      );
    } finally {
      replayLoading = false;
    }
  } catch (error: unknown) {
    reportErrorSentry(error);
  }
};
